// Vendor imports
const classNames = require('classnames')
const PropTypes = require('prop-types')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Sibling imports
const BaseCarousel = require('./base')

const bem = BemEntity('FeaturedCarousel')

function FeaturedCarousel(props) {
  const {
    className,
    items,
    renderSlide,
    ...nukaCarouselProps
  } = props
  return tag('div', {
    className: classNames(className, bem.block())
  },
    tag(BaseCarousel, {
      ...nukaCarouselProps,
      className: bem.element('slider'),
      renderBottomCenterControls: renderDots,
      renderCenterLeftControls: renderLeftButton,
      renderCenterRightControls: renderRightButton
    },
      items.map(renderSlide)
    )
  )
}

FeaturedCarousel.propTypes = {
  // Also passes props through to nuka-carousel
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderSlide: PropTypes.func.isRequired
}

FeaturedCarousel.defaultProps = {
  wrapAround: true
}

module.exports = FeaturedCarousel

function renderDots(carouselProps) {
  return BaseCarousel.renderDots({ bemEntity: bem, ...carouselProps })
}

function renderLeftButton(carouselProps) {
  return BaseCarousel.renderLeftButton({ bemEntity: bem, ...carouselProps })
}

function renderRightButton(carouselProps) {
  return BaseCarousel.renderRightButton({ bemEntity: bem, ...carouselProps })
}
